import React from 'react';
import './css/App.css';
import Navigation from './Components/Navigation';
import AppInfo from './Components/AppInfo';
import ShowCase from './Components/ShowCase';
import Production from './Components/Production';
import Experiences from './Components/Experiences';
import Services from './Components/Services';
import Footer from './Components/Footer';
import { getOSSImage } from './Components/Utils';

const HomeImage = getOSSImage('zhutu_tu.png');

function App() {
  return (
    <div className='app'>
      <img className="home-image" alt="home-image" src={HomeImage} />
      <AppInfo/>
      <ShowCase/>
      <Production/>
      <Experiences/>
      <Services/>
      <Footer/>
      <Navigation/>
    </div>
  )
}

export default App;
